import { UseQueryResult } from "@tanstack/react-query";
import { useState } from "react";
import { match } from "ts-pattern";

import { Props } from "~/components/quest/page/[id]/lib";
import {
  ApplyQuestTaskDoneInput,
  CurrentUserQuestProgressQuery,
  Sdk,
  UserQuestTaskProgressStatus,
} from "~/lib/graphql/client";

const useReviewRequest = ({
  client,
  questTask,
}: {
  client: Sdk;
  questTask: Props["quest"]["questTasks"][number];
}) => {
  const [connecting, setConnecting] = useState(false);
  const [success, setSuccess] = useState<boolean | undefined>(undefined);

  const reviewRequest = async (image: string, filename: string) => {
    const applyQuestTaskDoneInput: ApplyQuestTaskDoneInput = {
      questTaskId: questTask.id,
      items: [
        {
          image,
          filename,
          position: 0,
        },
      ],
    };

    setConnecting(true);
    await client
      .applyQuestTaskDone({
        input: applyQuestTaskDoneInput,
      })
      .then((res) => setSuccess(res.applyQuestTaskDone.success))
      .catch(console.error);

    setConnecting(false);
  };

  return { connecting, success, reviewRequest };
};

function getIsQuestTaskVerifyApplied(
  result: UseQueryResult<CurrentUserQuestProgressQuery, Error>,
  questTask: Props["quest"]["questTasks"][number]
) {
  return match(result)
    .with(
      { status: "success" },
      ({
        data: {
          me: { userQuestTaskProgresses },
        },
      }) =>
        // 記入済みなら true を返す
        [
          UserQuestTaskProgressStatus.Verified,
          UserQuestTaskProgressStatus.UnderReviewing,
        ].includes(
          userQuestTaskProgresses.find(
            (progress) => progress.questTaskId === questTask.id
          )?.status ?? UserQuestTaskProgressStatus.NotStartedYet
        )
    )
    .with({ status: "pending" }, () => false)
    .with({ status: "error" }, () => false)
    .exhaustive();
}

export { useReviewRequest, getIsQuestTaskVerifyApplied };
